var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-week-bar"},_vm._l((_vm.weekDaysItems),function(day){return _c('div',{key:("day-" + (day.index)),staticClass:"calendar-week-item",class:{
		'is-holiday' : _vm.isHoliday(day.index + 1) || _vm.isSpecialDay(day.index + 1) 
	}},[_vm._v(" "+_vm._s(day.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }